import { actionTypes } from '../../types';

// Action creator for generating OTP request
export const userListFilter = (payload) => ({
    type: actionTypes.GET_USER_LIST_FILTER_REQUEST,
    payload,
});

// Action creator for successful OTP generation
export const userListFilterSuccess = (payload) => ({
    type: actionTypes.GET_USER_LIST_FILTER_SUCCESS,
    payload,
});

// Action creator for failed OTP generation
export const userListFilterFailure = (payload) => ({
    type: actionTypes.GET_USER_LIST_FILTER_FAILURE,
    payload,
});

export const userListFilterReset = () => ({
    type: actionTypes.GET_USER_LIST_FILTER_RESET,
});

// Action creator for resetting all OTP generation reducer
export const userListFilterResetAll = () => ({
    type: actionTypes.GET_USER_LIST_FILTER_RESET_ALL,
});
